import { BasicInsuranceModelType } from '../../../api';
import { PersonSupplementaryInsuranceState } from '../../../states/offer/offer.state';

export const legacyTrackingIds: {
  [key in BasicInsuranceModelType | keyof PersonSupplementaryInsuranceState]: string;
} = {
  accidentDeathCapital: 'accident_death_capital',
  accidentDisabilityCapital: 'accident_disability_capital',
  outpatient: 'outpatient',
  outpatientViva: 'outpatient_viva',
  dailyCash: 'daily_cash',
  legalProtection: 'legal_protection',
  hospitalDailyCash: 'hospital_daily_cash',
  dental: 'dental',
  hospital: 'hospital',
  hospitalViva: 'hospital_viva',
  hospitalCapital: 'hospital_capital',
  complementary: 'complementary',
  complementaryViva: 'complementary_viva',
  basic: 'basic',
  emergencyCare: 'emergency_care',
  accidentMedicalExpensesSupplement: 'accident_medical_expenses_supplement',
  sicknessDeathOrDisabilityCapital: 'sickness_death_or_disability_capital',
  CASA_NOVA: 'casa_nova',
  MED_DIRECT: 'med_direct',
  MANAGED_CARE: 'managed_care',
  TEL_DOC: 'tel_doc',
  TEL_CARE: 'tel_care',
  COMBI_CARE: 'combi_care',
  MED_CALL: 'med_call',
  TRADITIONAL: 'traditional',
  //TODO naming:  DAP-4171
  VIVA: 'viva',
};
